import { Table } from "antd";
import { useEffect, useState } from "react";
import React from "react";
export const TableGrid = (props) => {
  const { currentComponent } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const columns = [];
    let isFirstColumn = true;
    if (
      !currentComponent ||
      !Array.isArray(currentComponent) ||
      !currentComponent[0]
    ) {
      return; // or handle empty state
    }
    for (const [key] of Object.entries(currentComponent[0])) {
      const title = `${key.charAt(0).toUpperCase() +
        key.slice(1).replaceAll("_", " ")}`;
      const dd = {
        // title: `${key.charAt(0).toUpperCase() +
        //   key.slice(1).replaceAll("_", " ")}`,
        title: title,
        dataIndex: `${key}`,
        key: `${key}`,
        align: "left",
        width: isFirstColumn ? 200 : Math.max(100, title.length * 8),
        ellipsis: {
          showTitle: false,
        },
        render: (text) => <span title={text}>{text}</span>,
      };
      columns.push(dd);
      setColumns(columns);
      isFirstColumn = false;
    }
    setData(currentComponent);
  }, [currentComponent]);

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        size="small"
        pagination={false}
        className="dashboard-tbl-scroll"
        scroll={{
          x: "max-content",
          y: 235,
        }}
      />
    </div>
  );
};
